import React, { useState, useEffect } from 'react';
import '../styles/TopMarquee.css';

const TopMarquee = () => {
  const [isVisible, setIsVisible] = useState(true);

  const messages = [
    {
      icon: "🎯",
      text: "🔥 LIMITED SLOTS AVAILABLE! Join our BYOB Program Today",
      link: "#byob-program",
      highlight: true
    },
    {
      icon: "⚡",
      text: "🚀LOWEST MOQ IN INDUSTRY",
      link: "#products",
      highlight: false
    },
    {
      icon: "🇮🇳",
      text: "💪 PROUDLY MADE IN INDIA | PAN-INDIA SUPPORT",
      link: "#why-partner",
      highlight: false
    },
    {
      icon: "📦",
      text: "🎯 CUSTOM BRANDING | PRIVATE LABEL AVAILABLE",
      link: "#byob-program",
      highlight: false
    },
  ];

  // Double the messages for seamless loop
  const allMessages = [...messages, ...messages];

  if (!isVisible) return null;

  return (
    <div className="top-marquee">
      <div className="top-marquee-container">
        <div className="top-marquee-track">
          {allMessages.map((message, index) => (
            <a 
              key={index} 
              href={message.link} 
              className={`top-marquee-item ${message.highlight ? 'highlight' : ''}`}
            >
              <span className="top-marquee-icon">{message.icon}</span>
              <span className="top-marquee-text">{message.text}</span>
              <span className="top-marquee-arrow">→</span>
            </a>
          ))}
        </div>
      </div>
      
      <button 
        className="top-marquee-close"
        onClick={() => setIsVisible(false)}
        aria-label="Close announcement"
      >
        ✕
      </button>
    </div>
  );
};

export default TopMarquee;